/**
 * Utility functions for converting Farsi/Persian numbers to English numbers
 */

/**
 * Converts Farsi/Persian digits (۰-۹) to English digits (0-9) in a string
 * @param {string} str - The string containing Farsi digits
 * @returns {string} - The string with English digits
 */
export function convertFarsiToEnglish(str) {
  if (typeof str !== 'string') {
    return str;
  }

  const farsiToEnglishMap = {
    '۰': '0',
    '۱': '1',
    '۲': '2',
    '۳': '3',
    '۴': '4',
    '۵': '5',
    '۶': '6',
    '۷': '7',
    '۸': '8',
    '۹': '9',
  };

  return str.replace(/[۰-۹]/g, (char) => farsiToEnglishMap[char] || char);
}

/**
 * Recursively normalizes form data by converting Farsi digits to English digits
 * Handles strings, objects, arrays, and other data types
 * @param {any} data - The data to normalize (can be string, object, array, etc.)
 * @returns {any} - The normalized data with English digits
 */
export function normalizeFormData(data) {
  // Handle null or undefined
  if (data === null || data === undefined) {
    return data;
  }

  // Handle strings - convert Farsi digits to English
  if (typeof data === 'string') {
    return convertFarsiToEnglish(data);
  }

  // Handle arrays - process each element recursively
  if (Array.isArray(data)) {
    return data.map((item) => normalizeFormData(item));
  }

  // Handle objects - process all values recursively
  if (typeof data === 'object' && data.constructor === Object) {
    const normalized = {};
    for (const [key, value] of Object.entries(data)) {
      normalized[key] = normalizeFormData(value);
    }
    return normalized;
  }

  // Handle other types (numbers, booleans, etc.) - return as-is
  return data;
}

